<template>
  <div class="student-leave" v-if="dataList.status_labels">
    <!-- 学年选择 -->
    <div class="year-selector" @click="showYearPicker = true">
      <span>{{ selectedYear }}</span>
      <van-icon name="arrow-down" size="12" />
    </div>

    <!-- 状态统计卡片 -->
    <div class="status-cards">
      <div class="status-card" :class="statusClass(key)" v-for="(item, key) in leaveStats" :key="key" @click="tabStatus(key)">
        <div class="status-num">
          <span class="num">{{ item }} <span class="dot" v-if='dataList.message_unread[key]!=0'></span></span>
        </div>
        <div class="status-label">{{ dataList.status_labels[key] }}</div>
        <img :src="statusIcon(key)" alt="" class="status-icon" />
      </div>
    </div>

    <!-- 加载中 -->
    <div class="leave-loading" v-if="loading">
      <van-loading color="#1989fa" size="24" />
    </div>

    <!-- 请假列表 -->
    <template v-else>
      <div class="leave-items" v-if="leaveList.length > 0">
        <div class="leave-item" :class="item.supplement_flag ? 'border-red' : ''" v-for="(item, index) in leaveList" :key="index" @click="handleClick(item)">
          <!-- 需补充材料提示 -->
          <div class="need-material" v-if="item.supplement_flag">
            <van-icon name="warning-o" color="#ED6A0C" size="15" />
            <span>{{ $t("leave.supplement_material") }}</span>
          </div>

          <!-- 学生信息行 -->
          <div class="student-row">
            <img :src="item.child_photo" class="student-avatar" />
            <span class="student-name">{{ item.child_name }}</span>
            <van-tag class="leave-type-tag" :color="item.leave_type === 30 ? '#E8F3FF' : '#FEF3E3'" :text-color="item.leave_type === 30 ? '#1989FA' : '#F5A429'">
              {{ item.leave_type_label }}
            </van-tag>
          </div>

          <!-- 日期列表 -->
          <div class="date-list">
            <div class="date-entry" v-for="(date, dIdx) in item.days" :key="dIdx">
              <span class="date-text">{{ date.leave_date_text }}</span>
              <span class="date-time">{{ date.time_label }}</span>
            </div>
          </div>

          <!-- 提交时间 -->
          <div class="submit-row">
            <div class="submit-time">{{ $t("leave.submitted_at") }} {{ item.submit_time_text }}</div>
            <div class="message" v-if='item.message_status==1'>
              <div class="new-message" v-if='item.message_parent_read==0'>
                <span class="dot"></span>
                <span class="text">{{ $t("leave.new_message") }}</span>
              </div>
              <van-icon name="comment-o" class="msg-icon" />
            </div>
          </div>
        </div>
      </div>
      <van-empty :description="$t('calendar.no_data')" v-else />
    </template>

    <!-- 底部请假按钮 -->
    <div class="bottom-btn">
      <div class="btn-add" @click="$router.push('/studentLeaveNew')"><van-icon name="plus" /> {{ $t("leave.new_leave") }}</div>
    </div>

    <!-- 学年选择器 -->
    <van-popup v-model="showYearPicker" position="bottom" round>
      <van-picker show-toolbar :title="$t('leave.select_year')" :columns="yearColumns" value-key="title" :default-index="defaultIndex" @confirm="onYearConfirm" @cancel="showYearPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Tag, Popup, Picker, Empty, Toast, Loading } from "vant";
Vue.use(Icon);
Vue.use(Tag);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Loading);

import { listLeave } from "@/api/leave";
const STATUS_CONFIG = {
  10: { name: "pending", icon: require("../assets/leave2.png"), activeIcon: require("../assets/leave(5).png") },
  20: { name: "approved", icon: require("../assets/leave1.png"), activeIcon: require("../assets/leave(1).png") },
  30: { name: "rejected", icon: require("../assets/leave3.png"), activeIcon: require("../assets/leave(3).png") },
};

export default {
  name: "StudentLeave",
  data() {
    return {
      showYearPicker: false,
      selectedYear: "",
      yearColumns: [],
      leaveStats: {},
      leaveList: [],
      loading: false,
      status: 10,
      year_id: "",
      dataList: {},
      defaultIndex: 0,
    };
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f7f8fa");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  created() {},
  activated() {
    this.getList();
  },
  methods: {
    statusClass(key) {
      const conf = STATUS_CONFIG[key] || {};
      return [conf.name, Number(key) === this.status ? "active" : ""];
    },
    statusIcon(key) {
      const conf = STATUS_CONFIG[key] || {};
      return Number(key) === this.status ? conf.activeIcon : conf.icon;
    },
    tabStatus(key) {
      this.status = Number(key);
      this.getList();
    },
    getList() {
      this.loading = true;
      listLeave({ year_id: this.year_id, status: this.status })
        .then((result) => {
          if (result.code == 0) {
            this.dataList = result.data;
            this.leaveList = result.data.items;
            this.leaveStats = result.data.counts;
            this.yearColumns = result.data.years;
            if (this.year_id == "") {
              const selected = result.data.years.find((item) => item.is_selected == 1);
              if (selected) {
                this.selectedYear = selected.title;
                this.year_id = selected.year_id;
                this.defaultIndex = result.data.years.indexOf(selected);
              }
            }
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
        });
    },
    onYearConfirm(val) {
      this.selectedYear = val.title;
      this.year_id = val.year_id;
      this.defaultIndex = this.yearColumns.findIndex((item) => item.year_id === val.year_id);
      this.showYearPicker = false;
      this.getList();
    },
    handleClick(item) {
      this.$router.push({ name: "StudentLeaveDetail", params: { id: item.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.student-leave {
  // min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 80px;

  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 10;

    .nav-icon {
      font-size: 20px;
      color: #323233;
      cursor: pointer;
    }

    .nav-title {
      font-size: 17px;
      font-weight: 600;
      color: #323233;
    }
  }

  .year-selector {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 16px;
    font-size: 14px;
    color: #323233;
    background: #fff;
    cursor: pointer;
  }

  .status-cards {
    display: flex;
    gap: 10px;
    padding: 10px 16px;
    background: #fff;

    .status-card {
      flex: 1;
      text-align: center;
      padding: 10px 8px;
      border-radius: 12px;
      position: relative;
      overflow: hidden;

      .status-num {
        font-size: 18px;
        font-weight: 700;
        line-height: 1;
        .num {
          position: relative;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 2px;
            background: #ff4d4f;
            border-radius: 50%;
            position: absolute;
            top: 0;
            right: -10px;
          }
        }
      }

      .status-label {
        font-size: 11px;
        margin-top: 4px;
      }
      .status-icon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 32px;
      }

      // 各状态主题（普通背景 + 激活背景）
      --bg: linear-gradient(135deg, rgba(25, 137, 250, 0.06) 0%, rgba(25, 137, 250, 0.2) 100%);
      --bg-active: #1989fa;

      &.approved {
        --bg: linear-gradient(135deg, rgba(7, 193, 96, 0.04) 0%, rgba(7, 193, 96, 0.16) 100%);
        --bg-active: #07c160;
      }

      &.rejected {
        --bg: linear-gradient(135deg, rgba(238, 10, 36, 0.04) 0%, rgba(238, 10, 36, 0.16) 100%);
        --bg-active: #ee0a24;
      }

      background: var(--bg);

      .status-num {
        color: #323233;
      }

      .status-label {
        color: #646566;
      }

      &.active {
        background: var(--bg-active);
        .status-num,
        .status-label {
          color: #fff;
        }
      }
    }
  }

  .leave-loading {
    display: flex;
    justify-content: center;
    padding: 80px 0;
  }

  .leave-items {
    padding: 0 12px;
    .border-red {
      border: 1px solid rgba(237, 106, 12, 0.1) !important;
    }
    .leave-item {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-top: 12px;
      border: 1px solid transparent;
      .need-material {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 11px;
        color: #ed6a0c;
        margin: -16px -16px 10px;
        background: #fdf0e6;
        padding: 6px 16px;
        line-height: 1;
        border-radius: 12px 12px 0px 0px;
      }

      .student-row {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .student-avatar {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .student-name {
          flex: 1;
          font-size: 12px;
          font-weight: 500;
          color: #323233;
        }

        .leave-type-tag {
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 4px;
        }
      }

      .date-list {
        background: #f7f8fa;
        border-radius: 8px;
        padding: 8px 12px;
        .date-entry {
          display: flex;
          align-items: baseline;
          padding: 4px 0;
          font-size: 13px;
          color: #646566;
          line-height: 1.2;
          .date-text {
            min-width: 140px;
            color: #323233;
            &::before {
              content: "";
              display: inline-block;
              background: #c8c9cc;
              margin-right: 6px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              vertical-align: middle;
              margin-top: -4px;
            }
          }

          .date-time {
            margin-left: auto;
            color: #646566;
            text-align: right;
          }
        }
      }

      .submit-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
      }

      .submit-time {
        font-size: 12px;
        color: #646656;
      }
      .message {
        display: flex;
        align-items: center;
        .new-message {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          color: #ee0a24;
          background: #feecee;
          border-radius: 2px;
          padding: 4px 6px;
          line-height: 1;
          position: relative;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 2px;
            background: #ff4d4f;
            border-radius: 50%;
          }

          &::before {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid #feecee;
            position: absolute;
            right: -4px;
          }
        }

        .msg-icon {
          font-size: 18px;
          margin-left: 8px;
        }
      }
    }
  }

  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    z-index: 10;

    .btn-add {
      text-align: center;
      padding: 12px 0;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background: #1989fa;
      border-radius: 24px;
      color: #e8f3ff;
    }
  }
}
</style>
